import React from 'react';
import PropTypes from 'prop-types';
import FloatingLabel from 'floating-label-react';

// import 'floating-label-react/styles.css';

const FloatingInput = ({
  name,
  type,
  placeholder,
  onChange,
  onBlur,
  value,
  touched,
  error,
  pos,
  required,
  icons,
  autocomplete,
}) => (
  <div
    className={`w-full font-malee pb-2 md:pb-4 relative ${pos === 'left' &&
      'md:w-1/2 md:pr-3'} ${pos === 'right' && 'md:w-1/2 md:pl-4'}`}
  >
    <FloatingLabel
      name={name}
      type={type}
      placeholder={placeholder}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      required={required}
      autoComplete={autocomplete}
      className={`${((touched && !error && value && icons != 'no-check') ||
        (!error && value && icons != 'no-check')) &&
        'input-checked'} ${touched &&
        error &&
        icons != 'no-error' &&
        'input-error'}`}
      // style={touched && error && { borderColor: 'red' }}
    />
    {/*{touched && !error && <Check />}
    {touched && error && <Error />}*/}
    {/* touched && error && <div className={'absolute'}>{error}</div> */}
  </div>
);

FloatingInput.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  touched: PropTypes.bool,
  error: PropTypes.string,
  required: PropTypes.bool,
  pos: PropTypes.string,
};

export default FloatingInput;
